import routes from '@/router/routes'
import store from '@/store'

export default function () {
  var navPages = {
    dashboard: undefined,
    operators: undefined,
    groups: undefined,
    filters: undefined,
    cifs: undefined,
    management: {
      title: 'management',
      icon: 'mdi-account-settings',
      color: 'secondary',
      disabled: true,
      available: false,
      subPages: [],
      component: 'AppBarItemMenu',
    },
    notifications: undefined,
    analytics: undefined,
    signatures: {
      /* need to be declared in case it has childs*/
      title: 'signatures',
      icon: 'mdi-signature-freehand',
      color: 'secondary',
      disabled: true,
      available: false,
      subPages: [],
      component: 'AppBarItemMenu',
      clickable: 'SignaturesView',
    },
    documentation: undefined,
    automatedTasks: undefined,
    news:
      store.getters.isMobile || store.getters.isDemoEnv
        ? undefined
        : {
            icon: 'mdi-bell',
            disabled: false,
            available: true,
            includeBadge: true,
            component: 'NewsList',
          },
    profile: {
      title: 'profile',
      icon: 'mdi-account-cog-outline',
      disabled: true,
      available: false,
      subPages: [],
      includeBadge: true,
      component: 'AppBarItemMenu',
    },
  }

  routes.forEach((routeInfo) => {
    const userCanAccess = routeInfo.meta.userCanAccess
    var navigationConfig = []
    navigationConfig = routeInfo.meta.navigationConfig()
    navigationConfig.forEach((navItem) => {
      const valueToPush = {
        title: navItem.title,
        component: navItem.component,
        icon: navItem.icon,
        path: navItem.path || routeInfo.path,
        routerData: navItem.routerData || { name: routeInfo.name },
        disabled: false,
        includeBadge: !!navItem.includeBadge,
        includeIcon: !!navItem.includeIcon,
        includeTitle: !!navItem.includeTitle,
        color: navItem.color ? navItem.color : 'secondary',
      }
      valueToPush.available = userCanAccess()
      //valueToPush.disabled = store.getters.isSubstituteMode

      if (!navItem.parent) navPages[valueToPush.title] = valueToPush
      else {
        if (valueToPush.available) navPages[navItem.parent].available = true
        navPages[navItem.parent].subPages.push(valueToPush)
      }
    })
  })

  Object.keys(navPages).forEach(
    (k) => (!navPages[k] || k === 'undefined') && delete navPages[k]
  )

  return navPages
}
